<template>
  <div class="radio-group ut-m-3 ut-flex ut-justify-start ut-items-center"
      v-bind:class="{'radio-disabled':disabled, 'radio-lrg':size == 'lrg', 'radio-active':radioButtonState}"
      @click="toggle()">
      <input
        type="radio"
        :id="id"
        :name="name"
        :value="radioValue"
        :disabled="disabled"
        :required="required"
        :selected="radioButtonState"
        @change="toggle()"
        v-gaEvent="{ category: gacategory, action: gaaction, label: setGaLabel }">
      <span></span>
      <label class="ut-ml-3 ut-cursor-pointer ut-text-neutral-400"
             :name="name"
             :for="id">
             <slot/>
      </label>
  </div>
</template>

<script>
export default {
  name: 'RadioButton',
  props: {
    id: {
      type: String,
      required: true,
    },
    name: {
      type: String,
      required: true,
    },
    size: {
      type: String,
      required: false,
      default: 'default',
    },
    selectedValue: {
      required: true,
    },
    radioValue: {
      required: true,
    },
    required: {
      type: Boolean,
      required: false,
    },
    disabled: {
      type: Boolean,
      required: false,
    },
    gacategory: {
      required: false,
      default: 'Dezi Component - Radio Button',
    },
    gaaction: {
      required: false,
      default: 'Clicked Radio Button',
    },
    galabel: {
      required: false,
      default: null,
    },
  },
  computed: {
    radioButtonState() {
      if (this.selectedValue === this.radioValue) {
        return true;
      }
      return false;
    },
    setGaLabel() {
      return this.galabel || `${this.name} - ${this.radioValue}`;
    },
  },
  methods: {
    toggle() {
      if (this.disabled) return;
      this.$emit('input', this.radioValue);
    },
  },
};
</script>

<style lang="scss" scoped>
.radio-group {
  input {
    display: none;
    visibility: hidden;
  }

  &.radio-active {
    span {
      border-color: #00AB55 !important;
    }
  }

  span {
    -webkit-appearance: none;
    -moz-appearance: none;
    @apply ut-rounded-full ut-bg-neutral001 ut-relative ut-cursor-pointer ut-appearance-none;
    @apply ut-text-transparent ut-border-2 ut-border-solid ut-text-center;

    border-color: #ccc;

    height: 20px;
    width: 20px;

    &:focus, &:active{
      outline: transparent;
      border-color: #00AB55;
    }

    &:hover {
      background-color: rgba(#00AB55, 0.2);
      box-shadow: 0px 0px 0px 10px rgba(#00AB55, 0.2);
    }

    &:after {
      @apply ut-rounded-full ut-absolute ut-visible;
      content: '';
      top:2px;
      left: 0px;
      right: 0px;
      margin: auto;

      height: 12px;
      width: 12px;
    }

    &:checked:after {
      @apply ut-text-C1 ut-border-neutral001;
      background-color: #00AB55;
    }

  }

  &:hover {

    span {
      background-color: rgba(#00AB55, 0.2);
      box-shadow: 0px 0px 0px 10px rgba(#00AB55, 0.2);
    }

  }

  &.radio-active span:after {
     @apply ut-text-C1 ut-border-neutral001;
     background-color: #00AB55;
  }

  label {
    @apply ut-text-sm;
  }

  &.radio-disabled {

    input {
      @apply ut-border-neutral200 ut-cursor-not-allowed;

      &:hover {
        @apply ut-shadow-none ut-bg-neutral001;
      }
    }

    label {
      @apply ut-text-neutral200 ut-cursor-not-allowed;
    }
  }

  &.radio-lrg {

    label {
      @apply ut-text-base;
    }

  }

}
</style>
